export default __webpack_public_path__ + "static/media/gallery2.6830ffe9.jpg";